var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Welcome'),_c('Covid'),_c('Intro'),_c('New2019'),_c('LiveRoom'),_c('Services'),_c('Equipment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }